import React, { useState, useEffect } from 'react';
import middleware from '../../Api/Middleware';
import ToastError from '../../Toasts/ToastError';
import { getCountryName } from '../../../utils';
import { formatPercentage } from '../../../utils';
import { BorderedDropDown } from '../../HouseStyle/Components/DropDowns';
import { BorderedTextInput } from '../../HouseStyle/Components/Inputs';
import { ButtonBlue, ButtonLightGrey } from '../../HouseStyle/Components/Buttons';

const Step2Branch = ({ data, updateData, onNext, onPrev }) => {
  const [tax, setTax] = useState([]);
  const [formData, setFormData] = useState({
    company_branch: data.company_branch || '',
    tax: data.tax || '',
    b2b_b2c: data.b2b_b2c || '',
    payment_term: data.payment_term !== undefined ? String(data.payment_term) : '14',
    phone_number_country_code: data.phone_number_country_code || '',
    phone_number: data.phone_number || ''
  });

const fetchAll = async () => {
  try {
    const taxRatesResponse = await middleware.get(`sp/taxRatesTableAll?filtering=country_code_id=${data.country}`);
    setTax(Object.values(taxRatesResponse.data)[0]);
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};

  useEffect(() => {
    fetchAll();
  }, [data.country]);

  // Update formData when data prop changes (when returning to this step)
  useEffect(() => {
    setFormData({
      company_branch: data.company_branch || '',
      tax: data.tax || '',
      b2b_b2c: data.b2b_b2c || '',
      payment_term: data.payment_term !== undefined ? String(data.payment_term) : '14',
      phone_number_country_code: data.phone_number_country_code || '',
      phone_number: data.phone_number || ''
    });
  }, [data]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Prevent negative payment_term
    if (name === 'payment_term') {
      const numValue = String(value).replace(/[^0-9]/g, '');
      setFormData(prev => ({
        ...prev,
        [name]: numValue
      }));
      updateData({ [name]: numValue });
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
      updateData({ [name]: value });
    }
  };

  const handleNext = () => {
    // Validate required fields
    const requiredFields = ['company_branch', 'tax', 'b2b_b2c', 'payment_term'];
    const missingFields = requiredFields.filter(field => !formData[field]);

    if (missingFields.length > 0) {
      ToastError(`Alle velden zijn verplicht.`);
      return;
    }
    // Payment term must be positive
    if (Number(formData.payment_term) < 1) {
      ToastError('Betaaltermijn factuur moet minimaal 1 dag zijn.');
      return;
    }
    onNext();
  };

  return (
    <div className="step-container">
      <div className="step-content-area">
        <div className="step-form">
          <h2 className="step-title">Branche & Standaard BTW tarief</h2>
          <p className="required-note">Invulvelden met een (*) zijn verplicht om in te vullen</p>
          <div className="col-md-12 mt-3">
            <BorderedDropDown
              size="s"
              label="Branche *"
              selectedValue={formData.company_branch}
              setSelectedValue={(value) => handleInputChange({ target: { name: 'company_branch', value } })}
              options={[
                { value: "0", title: "Detailhandel" },
                { value: "1", title: "Horeca" }
              ]}
              placeholder="..."
            />
          </div>
          <div className="col-md-12 mt-3">
            <BorderedDropDown
              size="s"
              label="Standaard BTW tarief *"
              selectedValue={formData.tax}
              setSelectedValue={(value) => handleInputChange({ target: { name: 'tax', value } })}
              options={[
                { value: "high", title: "Hoog" },
                { value: "reduced", title: "Laag" },
                { value: "zero", title: "Uitgesloten van BTW" }
              ]}
              placeholder="..."
            />
          </div>
          <div className="col-md-12 mt-3">
            <BorderedDropDown
              size="s"
              label="B2B / B2C *"
              selectedValue={formData.b2b_b2c}
              setSelectedValue={(value) => handleInputChange({ target: { name: 'b2b_b2c', value } })}
              options={[
                { value: "0", title: "Ja - Business to Business" },
                { value: "1", title: "Nee - Business to Consumer" }
              ]}
              placeholder="..."
            />
          </div>
          <div className="col-md-12 mt-3">
            <BorderedTextInput
              label="Betaaltermijn factuur (dagen) *"
              type="number"
              required={true}
              setInputValue={(value) => handleInputChange({ target: { name: 'payment_term', value } })}
              inputValue={formData.payment_term}
              placeholder="14"
              min={1}
              max={365}
            />
          </div>
        </div>

        {/* Info Sidebar */}
        <div className="info-sidebar">
          <div className="info-section">
            <h3>Standaard BTW tarief</h3>
            <p>{`Het BTW-tarief dat standaard wordt gebruikt voor uw producten en diensten. In ${getCountryName(tax?.country_code_2) || '-'} zijn de meest voorkomende tarieven ${formatPercentage(tax?.high_percentage) || '-'} (hoog tarief), ${formatPercentage(tax?.reduced_percentage) || '-'} (laag tarief) en ${formatPercentage(tax?.zero_percentage) || '-'} (vrijgesteld). Dit tarief wordt automatisch toegepast op nieuwe facturen.`}</p>
          </div>

          <div className="info-section">
            <h3>B2B / B2C</h3>
            <p>Geef aan of u voornamelijk zaken doet met bedrijven (B2B) of particuliere klanten (B2C). Dit is noodzakelijk bij het ingeven van prijzen inclusief BTW of exclusief BTW.</p>
          </div>
        </div>
      </div>

      <div className="form-actions">
        <ButtonLightGrey
          onClickFunction={onPrev}
          text="Terug"
        />
        <ButtonBlue
          onClickFunction={handleNext}
          text="Verder"
        />
      </div>
    </div>
  );
};

export default Step2Branch;